var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn_home act-text-stroke",style:({ backgroundColor: _vm.bColor, color: _vm.textColor }),on:{"click":function($event){return _vm.$goPage(_vm.url || 'index', _vm.$route.query)}}},[_vm._v("返回")])
}
var staticRenderFns = []

export { render, staticRenderFns }